<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-warehouse icon"></i>
        Distribuciones
      </div>

      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{ name: 'administratorHome' }">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{ name: 'cellar' }">
                <span>
                  <i class="fas fa-warehouse icon"></i>
                  Distribuciones
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">
          <b-button type="is-primary is-small" @click="openModalCreate"
            >Agregar Distribución</b-button
          >

          <b-table
            type="is-primary"
          :data.sync="listDistributions.data"
            :loading="loading"            
            :is-fullwidth="true"
            
           
            paginated
            backend-pagination
            :total="listDistributions.total"
            :per-page="listDistributions.per_page"
            @page-change="chargeListDistributions"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="ID" width="40" numeric>{{
                props.row.id
              }}</b-table-column>

              <b-table-column searchable field="name" label="Nombre">{{
                props.row.name
              }}</b-table-column>

              <b-table-column label="Action">
                <b-button
                  type="is-primary is-small"
                  @click="openModalEdit(props.row.id)"
                  >Editar</b-button
                >
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../../../template/PlantillaContenido";
import { DistributionService } from "../../../../services/models/distribution";
import CreateDistribution from "../../../../components/administrative/manteiners/distribution/CreateDistribution";
import EditDistribution from "../../../../components/administrative/manteiners/distribution/EditDistribution";

export default {
  components: {
    PlantillaContenido,
  },
  data() {
    return {
      listDistributions: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted: function () {
    this.chargeListDistributions();
  },
  methods: {
    openModalCreate() {
      this.$buefy.modal.open({
        parent: this,
        component: CreateDistribution,
        props: {
          chargeListDistributions: this.chargeListDistributions,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    openModalEdit(id) {
      this.$buefy.modal.open({
        parent: this,
        component: EditDistribution,
        props: {
          chargeListDistributions: this.chargeListDistributions,
          id: id,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async chargeListDistributions() {
      this.loading = true;
      this.listDistributions = [];
      const { data } = await DistributionService.getAll();
      this.listDistributions = data;
      this.loading = false;
    },
  },
};
</script>

